import { render, staticRenderFns } from "./ConfirmMail.vue?vue&type=template&id=2c6e7023&scoped=true"
import script from "./ConfirmMail.vue?vue&type=script&lang=js"
export * from "./ConfirmMail.vue?vue&type=script&lang=js"
import style0 from "./ConfirmMail.vue?vue&type=style&index=0&id=2c6e7023&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6e7023",
  null
  
)

export default component.exports